<template>
  <div class="container">
    <div
      class="app-overview"
      :class="{'app-overview--reverse': isReverse}"
    >
      <div class="app-overview__content">
        <slot />
      </div>

      <div
        class="app-overview__img"
        :class="imgClass"
      >
        <img
          v-if="imgSrc"
          :src="imgSrc"
          :alt="imgAlt"
        >

        <lottie
          v-if="lottieData"
          v-observe-visibility="{
            callback: lottieVisibilityChanged,
            intersection: {
              // Call callback when animation is 100% in viewport.
              threshold: 1
            },
            once: true
          }"
          :options="lottieOptions"
          @animCreated="handleAnimation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'vue-lottie/src/lottie.vue'

export default {
  name: 'AppOverview',

  components: {
    lottie
  },

  props: {
    isReverse: {
      type: Boolean,
      required: false,
      default: false
    },

    imgSrc: {
      type: String,
      required: false,
      default: ''
    },

    imgAlt: {
      type: String,
      required: false,
      default: ''
    },

    imgClass: {
      type: String,
      required: false,
      default: ''
    },

    lottieData: {
      type: Object,
      required: false,
      default: null
    },

    list: {
      type: Array,
      required: false,
      default: null
    }
  },

  data () {
    return {
      animation: null,
      lottieOptions: {
        animationData: this.lottieData,
        autoplay: false
      }
    }
  },

  methods: {
    handleAnimation (animation) {
      this.animation = animation
    },

    lottieVisibilityChanged (isVisible) {
      // Play the animation if visible in viewport.
      if (isVisible) this.animation.play()
    }
  }
}
</script>

<style scoped lang="scss">
.app-overview {
  @apply flex flex-col-reverse items-center justify-between max-w-400 mx-auto my-30;

  @screen md {
    @apply flex-row max-w-full;
  }

  &--reverse {
    @screen md {
      @apply flex-row-reverse;
    }
  }

  &__content {
    @apply flex flex-col relative mt-20;

    @screen md {
      @apply mr-50 -mt-40 w-390;

      :deep() h2 {
        @apply mb-30;
      }
    }

    @screen lg {
      @apply mr-100 w-475;
    }
  }

  &--reverse &__content {
    @screen md {
      @apply ml-50 mr-0;
    }

    @screen lg {
      @apply ml-100 mr-0;
    }
  }

  &__img {
    @apply mb-30;

    @screen md {
      @apply flex-1 mb-0 -mr-60;
    }

    @screen lg {
      @apply mr-0;
    }

    img {
      @apply w-full;
    }
  }

  &--reverse &__img {
    @screen md {
      @apply -ml-60 mr-0;
    }

    @screen lg {
      @apply ml-0;
    }
  }

  &__item {
    @apply flex mb-20;

    &:last-child {
      @apply mb-0;
    }

    @screen md {
      @apply mb-30;
    }

    span {
      @apply flex-1;
    }
  }

  &__icon {
    @apply mr-15 mt-[2px];
  }

  &__cta {
    @apply block text-center;

    @screen sm {
      @apply text-left;
    }
  }
}
</style>
